import Icon from "@material-ui/icons/EmojiTransportation";
import SubcontractorList from "./SubcontractorList";
import SubcontractorShow from "./SubcontractorShow";

// eslint-disable-next-line import/no-anonymous-default-export
export default {
  name: "subcontractors",
  list: SubcontractorList,
  show: SubcontractorShow,
  icon: Icon,
};
